// extracted by mini-css-extract-plugin
export default {"mentionUserLink":"userCard-module--mention-user-link--QP-Z3"};